import {Component, Input, OnInit} from '@angular/core';
import {RatingQualities} from '../../../../generated-api';

@Component({
    selector: 'app-qualities-list',
    templateUrl: './qualities-list.component.html',
    styleUrls: ['./qualities-list.component.scss'],
    standalone: false
})
export class QualitiesListComponent implements OnInit {
  @Input() qualities: RatingQualities;

  constructor() {
  }

  ngOnInit(): void {
  }

  getIcon(q: any): string {
    switch (q) {
      case 'humor':
        return 'tag_faces';
      case 'wissen':
        return 'school';
      case 'machart':
        return 'movie';
      case 'vorbild':
        return 'escalator_warning';
      case 'spannung':
        return 'flash_on';
      case 'botschaft':
        return 'campaign';
      default:
        return 'donut_large';
    }
  }
}
